import { render, staticRenderFns } from "./longTermRentRate.vue?vue&type=template&id=3675b0b4&scoped=true&"
import script from "./longTermRentRate.vue?vue&type=script&lang=js&"
export * from "./longTermRentRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3675b0b4",
  null
  
)

export default component.exports